import { render } from "./AttendanceSettingsDialog.vue?vue&type=template&id=46e55c05&scoped=true"
import script from "./AttendanceSettingsDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceSettingsDialog.vue?vue&type=script&lang=js"

import "./AttendanceSettingsDialog.vue?vue&type=style&index=0&id=46e55c05&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e55c05"]])

export default __exports__